import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Baseproperties } from '../../utility/baseproperties';

@Injectable({
  providedIn: 'root'
})
export class UnlicenseduserserviceService {
constructor(private httpClient: HttpClient) { }
  baseproperties: Baseproperties = new Baseproperties();
  private baseURL = this.baseproperties.gatewayBaseURL + '/common/unlicensedusers'

  getproducts(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/getproducts`);
  }

  getalldata(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/getalldata/`, payload);
  }

  getstatus(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/getstatus/`, payload);
  }

  getproductfilter(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/getproductfilter/`, payload);
  }

  getusertype(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/getusertype/`, payload);
  }
  
  getmodify(userid): Observable<any> {
    return this.httpClient.get<any>(`${this.baseURL}/getmodify/${userid}`);
  }

  modifyUser(payload): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/modifyuser`, payload);
  }
 
  addUser(payload): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/adduser`, payload);
  }  

  deleteUser(payload): Observable<any> { 
    return this.httpClient.delete(`${this.baseURL}/deleteuser`,{params:payload});
  }
}
